import { Injectable } from '@angular/core';

import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { EarlyPayoutAcceptance } from '@frontend/sports/user/feature';

import { IBetslip } from '../../../../bet-generation/models';
import { EditBetEarlyPayoutChangedPreCheckError } from '../../../errors/pre-check/edit-bet-early-payout-changed-pre-check-error';
import { EditBetValidationContext } from '../../../models/models';
import { IEditBetBetslipValidator } from './validators';

/**
 * Validates current EP value and accept EP value against user settings.
 * Generates {@link EditBetEarlyPayoutChangedPreCheckError} if does not match.
 */
@Injectable()
export class EditBetEarlyPayoutChangedValidator implements IEditBetBetslipValidator<EditBetEarlyPayoutChangedPreCheckError> {
    validate(_: IBetslip, context: EditBetValidationContext, acceptance: Nullable<EarlyPayoutAcceptance>): EditBetEarlyPayoutChangedPreCheckError[] {
        if (
            acceptance !== EarlyPayoutAcceptance.Higher ||
            context.earlyPayoutStake === null ||
            context.acceptedEarlyPayoutStake === null ||
            context.earlyPayoutStake >= context.acceptedEarlyPayoutStake
        ) {
            return [];
        }

        return [new EditBetEarlyPayoutChangedPreCheckError(context.earlyPayoutStake, context.acceptedEarlyPayoutStake)];
    }
}
